module.exports = __webpack_public_path__ + "img/icon_close.3a9f4b3c.svg";